import { isPlatformServer } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnDestroy,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { Subject, asyncScheduler, takeUntil, throttleTime } from 'rxjs';
import { ScrollService } from '../../../services/scroll.service';

@Component({
  selector: 'app-scroll-progress-indicator',
  standalone: true,
  imports: [],
  templateUrl: './scroll-progress-indicator.component.html',
  styleUrl: './scroll-progress-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollProgressIndicatorComponent implements OnDestroy {
  private scrollService = inject(ScrollService);
  private platformId = inject(PLATFORM_ID);
  private check = inject(ChangeDetectorRef);
  @HostBinding('style.--progress-width') scrollProgress: string;
  destroy$ = new Subject<void>();

  private throttledScrollWatcher = this.scrollService.onScroll
    .pipe(takeUntil(this.destroy$), throttleTime(100, asyncScheduler, { trailing: true, leading: true }))
    .subscribe(() => this.calculateScrollProgress());

  // private debouncedScrollWatcher = this.scrollService.onScroll
  //   .pipe(takeUntil(this.destroy$), debounceTime(250))
  //   .subscribe(() => this.calculateScrollProgress());

  calculateScrollProgress() {
    if (isPlatformServer(this.platformId)) return;
    const el = document.scrollingElement;
    const storyHeight = document.querySelector('article')?.clientHeight;
    const progress = Math.min((el.scrollTop / (storyHeight - window.innerHeight)) * 100, 100);
    this.scrollProgress = `${progress}%`;
    this.check.markForCheck();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
